import QuestionRenderer from './QuestionRenderer';
export default QuestionRenderer;